import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function LogoIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="LogoIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100" fill="currentColor" enableBackground="new 0 0 100 100"
      xmlSpace="preserve">
      <ellipse transform="matrix(0.8507 -0.5257 0.5257 0.8507 1.6158 27.7592)" cx="49.666" cy="11.036" rx="10.036" ry="10.036"/>
      <path d="M52.678,61.998l-11.755-9.872c-1.001-0.84-1.295-2.257-0.711-3.426l10.612-21.262H37.556L29.5,43.588
	c-2.557,5.125-2.347,12.409,4.266,18.045l12.707,10.699c0.884,0.745,1.144,1.998,0.628,3.033L34.81,100h13.342l9.715-19.475
	C61.463,73.319,57.774,66.294,52.678,61.998z"/>
      <polygon points="25.767,27.438 12.499,27.438 2.679,47.123 11.52,55.997 	"/>
      <polygon points="2.477,100 16.021,100 29.592,72.797 20.567,63.739 	"/>
      <polygon points="100,100 64.854,25.622 54.099,45.971 67.412,45.971 92.942,100 	"/>
    </svg>
  </SvgIcon>
}

export default LogoIcon;
